module.exports = __webpack_public_path__ + "static/media/P2_S1_1.b2eb3848.png";